import { Input, Table } from "reactstrap";
import { IIndividualLight, IPositionAssignment, PositionMembershipTypes } from "../../../../types/individual";
import React, { ChangeEvent, useState } from "react";
import SpinnerOverlay from "../../../common/spinner/spinner";
import OmsToolTip from "../../../common/oms-tooltip/oms-tooltip";
import PaginationBar from "../../../common/pagination-bar";
import { Pageable } from "../../../../types/common";
import TableHeaders, { TableHeaderInfo } from "../../../common/table-header";

interface IndividualsListProp extends Pageable {
    onSelect: (selectedBusinessEntityId: number, isSelected: boolean)=>void;
    individuals: Partial<IIndividualLight>[];
    selectedBusinessEntityIds: number[] ;
    showCreateTable: boolean;
    loading: boolean;
    membershipType: PositionMembershipTypes
}

const TABLE_HEADERS: TableHeaderInfo<Partial<IIndividualLight>>[] = [
  { header: '', cssClass: "icon-column" },
  { header: "Individual Name", presorted: 'asc' },
  { header: "Position/Role" },
  { header: "Organization" }
];

const IndividualsList = (props: IndividualsListProp) => {
    const { onSelect, individuals, selectedBusinessEntityIds, membershipType, loading, showCreateTable, pageSize=10} = props;
    const [pagedData, setPagedData] = useState<Partial<IIndividualLight>[]>([]);
    const isChecked = (individual: Partial<IIndividualLight>): boolean => {
        return membershipType === PositionMembershipTypes.PositionIndividual
            ? selectedBusinessEntityIds.some(item => item === individual.individualId)
            : selectedBusinessEntityIds.some(item => item === (individual.positionId ?? individual.individualId));
    }

    const handleSelect = (event: ChangeEvent<HTMLInputElement>, individual: Partial<IIndividualLight>) => {
        const selectedBusinessEntityId = membershipType === PositionMembershipTypes.PositionIndividual 
            ? individual.individualId!
            : individual.positionId ?? individual.individualId!;

        console.log(selectedBusinessEntityId);
        onSelect(selectedBusinessEntityId, event.target.checked);
    }

    function formatPositionName(record: IPositionAssignment | Partial<IIndividualLight>) : string {
        if ('position' in record) {
            // IPositionAssignment
            const positionAssignment = record as IPositionAssignment;
            return `${positionAssignment.position.fullPositionName} (${positionAssignment.relType?.label ?? 'Vacant'})`;
        }
        else {
            const individual = record as Partial<IIndividualLight>;
            return `${individual.positionFullName} (${individual.relationshipType ?? 'Vacant'})`;
        }
    }

    console.log(`${Date.now()} repaint individuals-list? ${individuals.length}.${selectedBusinessEntityIds.length}`);

    return (
        <div className="add-individuals-modal-table" >
            {loading && <SpinnerOverlay />}
            {showCreateTable &&  <Table striped className="organizations-table fixed" id="create-individual">
                <thead>
                    <tr>
                        <th className="icon-column">
                            <div className="hidden-text ">Select</div>
                        </th>
                        <th>Individual Name</th>
                        <th>Email</th>
                        <th>Position/Role</th>
                    </tr>
                </thead>
                <tbody>
                    {(!individuals || individuals.length === 0) 
                        ? (<tr><td colSpan={4} className="text-center">No Individuals found.</td></tr>)
                        : (individuals.map((indi:Partial<IIndividualLight>,index: number) => (
                            <React.Fragment key={index}>
                                {indi.positionAssignments && indi.positionAssignments.length===1 && (
                                    <tr key={index}>
                                        <td >
                                            <Input
                                                type="checkbox"
                                                aria-label={'Select individual ' + indi.individualFullName}
                                                checked={isChecked(indi)}
                                                onChange={(event) => handleSelect(event, indi)}
                                            />
                                        </td>
                                        <td >{indi.individualFullName}</td>
                                        <td >{indi.email}</td>
                                        <td>
                                            {
                                                indi.positionAssignments[0].position?.fullPositionName && (
                                                    <OmsToolTip positionId={indi.positionAssignments[0].position.positionId}>
                                                        {formatPositionName(indi.positionAssignments[0])}
                                                    </OmsToolTip>
                                                )
                                            }
                                        </td>
                                    </tr>
                                )}
                                {indi.positionAssignments && indi.positionAssignments.length>1 && (
                                    <tr key={index}>
                                        <td rowSpan={indi.positionAssignments.length}>
                                            <Input
                                                type="checkbox"
                                                aria-label={'Select individual ' + indi.individualFullName}
                                                checked={isChecked(indi)}
                                                onChange={(event) => handleSelect(event, indi)}
                                            />
                                        </td>
                                        <td rowSpan={indi.positionAssignments.length}>{indi.individualFullName}</td>
                                        <td rowSpan={indi.positionAssignments.length}>{indi.email}</td>
                                        <td>
                                            { indi.positionAssignments[0].position?.fullPositionName && (
                                                    <OmsToolTip positionId={indi.positionAssignments[0].position.positionId}>
                                                        {formatPositionName(indi.positionAssignments[0])}
                                                    </OmsToolTip>
                                                )
                                            }
                                        </td>
                                    </tr>
                                )}
                                {indi.positionAssignments && indi.positionAssignments.length>1 && (
                                    indi.positionAssignments.map((pos, posIndex) => (
                                        posIndex!==0 && (
                                    <tr key = {index*100+posIndex}>
                                        <td>
                                            { pos.position?.fullPositionName && (
                                                <OmsToolTip positionId={pos.position.positionId}>
                                                    {formatPositionName(pos)}
                                                </OmsToolTip>
                                            )}
                                        </td>
                                    </tr>)))
                                )}
                                {((!indi.positionAssignments)||(indi.positionAssignments.length<1)) && (
                                    <tr key={index}>
                                        <td>
                                            <Input
                                                type="checkbox"
                                                aria-label={'Select individual ' + indi.individualFullName}
                                                checked={isChecked(indi)}
                                                onChange={(event) => handleSelect(event, indi)}
                                            />
                                        </td>
                                        <td>{indi.individualFullName}</td>
                                        <td>{indi.email}</td>
                                        <td></td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))
                    )}
                    </tbody>
                </Table>
          }
          {!showCreateTable &&
            <Table striped className="organizations-table fixed" id="select-individual">
                <TableHeaders headers={TABLE_HEADERS} />
                <tbody> 
                {(!individuals || individuals.length===0) 
                    ? ( <tr><td colSpan={4} className="text-center">No Individuals found.</td></tr> ) 
                    :  (pagedData.map((indi, index) => (
                        <React.Fragment key={index}>
                            <tr key={index}>
                                <td>
                                    <Input
                                        type="checkbox"
                                        aria-label={'Select individual ' + indi.individualFullName}
                                        checked={isChecked(indi)}
                                        onChange={(event) => handleSelect(event, indi)}
                                    />
                                </td>
                                <td>{indi.individualFullName}</td>
                                <td>{indi.positionFullName && (
                                    <OmsToolTip positionId={indi.positionId}>
                                        {formatPositionName(indi)}
                                    </OmsToolTip>
                                )}</td>
                                <td>
                                    {indi.organizationName ?? ''}
                                </td>
                            </tr>
                        </React.Fragment>
                    ))
                )
            }
            </tbody>
        </Table>
        }

        <PaginationBar data={individuals} pageSize={pageSize} onPageChange={setPagedData} />
      </div>
    )
}

export default IndividualsList;
